import React, { useEffect, useState } from "react";
import "./slider.css";

export default function ClientSlider({ clients }) {
  const [left, setLeft] = useState(0);
  const [countdown, setCountdown] = useState();
  const maxCount = clients?.length;
  const leftOffset = 280;

  useEffect(() => {
    // console.log(countdown);
    const timer = setInterval(() => {
      if (countdown > 1) {
        setCountdown(countdown - 1);
        if (countdown < maxCount) {
          setLeft(left + leftOffset);
        }
      } else {
        setCountdown(maxCount);
        const el = document.getElementById("client-scroll");
        // console.log("LEFT ", left);
        if (el) {
          console.log("LEFT ", left);
          el.scrollLeft -= left;
        }
        setLeft(0);
      }
    }, 1000);

    return () => {
      clearInterval(timer);
    };
  }, [countdown]);

  useEffect(() => {
    const el = document.getElementById("client-scroll");
    // console.log("LEFT ", left);
    if (el && left > 0) {
      // console.log("LEFT ", left);
      el.scrollLeft += leftOffset;
    }
  }, [left]);

  return (
    <div>
      <div
        id="client-scroll"
        className="client-scroll"
        style={{
          whiteSpace: "nowrap",
          overflow: "hidden",
          scrollBehavior: "smooth",
        }}
      >
        {clients?.map((client, index) => (
          <div className="item">
            <img
              key={"client-" + index}
              src={client["url"]}
              alt={client["alt"]}
            />
          </div>
        ))}
      </div>
    </div>
  );
}
